import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { useTranslate } from "react-redux-multilingual";
import { scrollTop } from "components/standart";
import { setNavi, setHideHeader } from "actions";
import {
  BlockSection,
  CustomBlockSection,
  IntroSection,
  TariffsSection,
} from "components/standart/LandingSections";
import { fileUrl } from "reducers/api";
import TelegramButton from "components/standart/mediaButtons";

// import CastsRecomendation from "./casts/recomendation";
// import { RoundTelegramButton } from "components/standart/mediaButtons";

const Index = (props) => {
  const translate = useTranslate();
  const { env } = useSelector((state) => state.frontend);

  const { meta = {}, settings = {} } = env;

  useEffect(() => {
    scrollTop();
    props.setNavi("/");
    props.setHideHeader(false);

    const startInstagramVisual = () => {
      try {
        window.instgrm.Embeds.process();
      } catch (e) {
        setTimeout(startInstagramVisual, 500);
      }
    };
    setTimeout(startInstagramVisual, 500);
  }, []);
  const {
    title = translate("title_index"),
    description = translate("title_description"),
    keywords = "",
    fileId,
  } = meta.index || {};
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta property="og:title" content={title} />
        <meta name="og:description" content={description} />
        <meta name="og:keywords" content={keywords} />
      </Helmet>
      {fileId ? (
        <Helmet>
          <meta property="og:image" content={fileUrl(fileId, "image.jpg")} />
          <meta property="image" content={fileUrl(fileId, "image.jpg")} />
        </Helmet>
      ) : null}

      <BlockSection type="index" blockName="intro" paddingTop={2} paddingBottom={0} />
      <BlockSection type="index" blockName="block1" paddingTop={4} />
      <BlockSection type="index" blockName="block2" paddingTop={4} />
      <BlockSection type="index" blockName="block3" paddingTop={4} />
      <BlockSection type="index" blockName="block4" paddingTop={4} />
      <BlockSection type="index" blockName="block5" paddingTop={4} />
      <BlockSection type="index" blockName="block6" paddingTop={4} />

      <TariffsSection
        name="tariffsBlock1"
        containerClass="rounded-xl bg-grey pt-3 pb-4 px-3"
        paddingTop={2}
        paddingBottom={0}
        marginTop={4}
        marginBottom={4}
      />
      <TariffsSection
        name="tariffsBlock2"
        containerClass="rounded-xl bg-grey pt-3 pb-4 px-3"
        paddingTop={2}
        paddingBottom={0}
        // marginTop={0}
        marginBottom={4}
      />

      <BlockSection
        type="index"
        // bgColor="bg-grey"
        containerClass="rounded-xl bg-grey pt-3 pb-4 px-3"
        paddingTop={0}
        paddingBottom={0}
        // marginTop={0}
        marginBottom={4}
        blockName="extra"
      />

      <BlockSection
        type="index"
        // bgColor="bg-grey"
        containerClass="rounded-xl bg-grey pt-3 pb-4 px-3"
        paddingBottom={0}
        paddingTop={0}
        blockName="block7"
      />

      <BlockSection type="index" paddingTop={4} blockName="block8" />

      <div className="my-4" />
    </>
  );
};

export default connect(null, {
  setNavi,
  setHideHeader,
})(Index);
